import React from 'react';
import PropTypes from 'prop-types';

const RatingScaleIconItem = ({
  enableFillColor,
  emptyIcon,
  fullIcon,
  containerClassName,
  fullIconContainerClassName,
}) => {
  return (
    <div className={containerClassName}>
      {emptyIcon}
      {enableFillColor && <span className={fullIconContainerClassName}>{fullIcon}</span>}
    </div>
  );
};

RatingScaleIconItem.propTypes = {
  enableFillColor: PropTypes.bool,
  emptyIcon: PropTypes.object,
  fullIcon: PropTypes.object,
  containerClassName: PropTypes.string,
  fullIconContainerClassName: PropTypes.string,
};

export default RatingScaleIconItem;
